module.exports = __webpack_public_path__ + "img/empty_notifications.b9f4f000.jpg";